<template>
    <div>
        <div class="scrmBox">
            <div class="scrmContBG1">
                <div class="scrmCont">
                    <img class="scrmImg" src="@/assets/img/scrmT1.png" alt="">
                    <div class="scrmTextBox pl180">
                        <div class="scrmTitle">线索管理</div>
                        <div class="scrmText mt10">多渠道线索对接</div>
                        <div class="scrmText mt38">线索接入</div>
                        <div class="scrmText mt10">多场景获客</div>
                        <div class="scrmText mt10">渠道ROI分析</div>
                    </div>
                </div>
            </div>
            <div class="scrmContBG2">
                <div class="scrmCont">
                    <div class="scrmTextBox pl70">
                        <div class="scrmTitle">客户管理</div>
                        <div class="scrmText mt10">客户资料全方位统一管理</div>
                        <div class="scrmText mt38">客户信息管理</div>
                        <div class="scrmText mt10">企微好友、企微群同步</div>
                        <div class="scrmText mt10">客户资源保护</div>
                    </div>
                    <img class="scrmImg" src="@/assets/img/scrmT2.png" alt="">
                </div>
            </div>
            <div class="scrmContBG1">
                <div class="scrmCont">
                    <img class="scrmImg" src="@/assets/img/scrmT3.png" alt="">
                    <div class="scrmTextBox pl180">
                        <div class="scrmTitle">营销管理</div>
                        <div class="scrmText mt10">多渠道、多场景规模获客</div>
                        <div class="scrmText mt38">获客助手</div>
                        <div class="scrmText mt10">表单</div>
                        <div class="scrmText mt10">内容营销库</div>

                    </div>
                </div>
            </div>
            <div class="scrmContBG2">
                <div class="scrmCont">
                    <div class="scrmTextBox pl70">
                        <div class="scrmTitle">销售管理</div>
                        <div class="scrmText mt10">销售效率及客户转化率，实现精准转化</div>
                        <div class="scrmText mt38">商机</div>
                        <div class="scrmText mt10">会话存档</div>
                        <div class="scrmText mt10">商机分析</div>
                    </div>
                    <img class="scrmImg" src="@/assets/img/scrmT4.png" alt="">
                </div>
            </div>
            <div class="scrmContBG1">
                <div class="scrmCont">
                    <img class="scrmImg" src="@/assets/img/scrmT5.png" alt="">
                    <div class="scrmTextBox pl180">
                        <div class="scrmTitle">活动管理</div>
                        <div class="scrmText mt10">智能活动，精准营销，提升引流效果</div>
                        <div class="scrmText mt38">活动日历可视化</div>
                        <div class="scrmText mt10">智能活动路径</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "scrm"
    }
</script>

<style scoped>
.scrmBox{
    margin-top: 10px;
}
.scrmCont{
    width: 1200px;
    display: flex;
    justify-content: space-between;
}
.scrmImg{
    width: 560px;
}
.scrmTextBox{
    width: 560px;
}
.scrmTitle{
    font-size: 24px;
    color: #333333;
    font-weight: bold;
}
.scrmText{
    font-size: 18px;
    color: #333333;
}
.mt10{
    margin-top: 10px;
}
.mt38{
    margin-top: 38px;
}
.scrmContBG1{
    background: #F8F8F8;
    width: 100vw;
    display: flex;
    justify-content: center;
    padding: 55px 0;
}
.pl180{
    padding-left: 180px;
}
.pl70{
    padding-left: 70px;
}
.scrmContBG2{
    width: 100vw;
    display: flex;
    justify-content: center;
    padding: 55px 0;
}
/*    */
</style>